@if (multi?.length) {
  <div class="full">
    <ngx-charts-bar-horizontal-stacked
      class="full"
      [scheme]="colorScheme"
      [results]="multi"
      [gradient]="gradient"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [legend]="showLegend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [xAxisTickFormatting]="millisToHours"
      [yAxisLabel]="yAxisLabel"
      (select)="onSelect($event)"
    >
      <ng-template #tooltipTemplate let-model="model">
        <div class="layout-col">
          <p>
            {{ 'jobs.work-item' | translate }}: {{ model.name }} <br/>
            {{ 'jobs.utilisation' | translate }}: {{ millisToDuration(model.value) | isoDuration }}
          </p>
        </div>
      </ng-template>
    </ngx-charts-bar-horizontal-stacked>
  </div>
}

@if (multi?.length === 0) {
  <div class="full">
    <p>No enforced assignments</p>
  </div>
}
